import URLSearchParams from '@ungap/url-search-params';

export const getURLParameters = (name: string): string => {
  if (typeof window !== 'undefined') {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(name);
  }
  return '';
};

export const getAndDeleteURLParameters = (name: string): string | null => {
  if (typeof window !== 'undefined') {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has(name)) {
      searchParams.delete(name);
      return searchParams.toString();
    } else {
      return null;
    }
  }
  return null;
};
